// @flow
import Loadable from '@src/components/Loadable';

const TimeLineLoader = Loadable({
  loader: () => import('./TimeLine'),
});

export default TimeLineLoader;
